import Spiral from './string_art_types/Spiral.pattern';
import Spirals from './string_art_types/Spirals.pattern';
import Wave from './string_art_types/Wave.pattern';
import Eye from './string_art_types/Eye.pattern';
import Mandala from './string_art_types/Mandala.pattern';
import Star from './string_art_types/Star.pattern';
import Assymetry from './string_art_types/Assymetry.pattern';
import Freestyle from './string_art_types/Freestyle.pattern';
import PolygonPattern from './string_art_types/Polygon.pattern';
import Flower from './string_art_types/Flower.pattern';
import MaurerRose from './string_art_types/MaurerRose.pattern';
import FlowerOfLife from './string_art_types/FlowerOfLife.pattern';
import Comet from './string_art_types/Comet.pattern';
import Sun from './string_art_types/Sun.pattern';
import Lotus from './string_art_types/Lotus.pattern';
import DanceOfPlanets from './string_art_types/DanceOfPlanets.pattern';
import Crosses from './string_art_types/Crosses.pattern';
import HexagonSpades from './string_art_types/HexagonSpades.pattern';
import StarOfDavid from './string_art_types/StarOfDavid.pattern';

const patternTypes = [
  Star,
  Assymetry,
  Mandala,
  Spiral,
  Spirals,
  Wave,
  Eye,
  Freestyle,
  PolygonPattern,
  Flower,
  MaurerRose,
  FlowerOfLife,
  Comet,
  Sun,
  Lotus,
  DanceOfPlanets,
  Crosses,
  HexagonSpades,
  StarOfDavid,
];

export default patternTypes;
